export default {
  home: "/",
  login: "/login",
  signUp: "/sign-up",
  verifyEmain: "/sign-up/verify-email",
  resetPassword: "/reset-password",
  menus: "/menus",
  // TODO: change to /orders
  checkout: "/orders/:orderId/checkout",
  checkoutForm: "/orders/:orderId/checkout/:formId",
  orderStatus: "/orders/:orderId/status",
  loyalty: "/loyalty",
  customerProfile: "/perfil",
  testDigital: "/test-digital",
  //
  notFound: "404",
  onboarding: {
    main: "/onboarding",
    setup: "/onboarding/setup",
    finished: "/onboarding/finished",
  },
  templates: {
    main: "/super-admin/plantillas",
    create: "/super-admin/plantillas/crear",
    edit: "/super-admin/plantillas/:templateId/:organizationId/editor",
  },
  elements: {
    main: "/super-admin/plantillas/:templateId/:organizationId/editor/:elementId",
  },
  admin: {
    menus: {
      main: "/comercios/:organizationId/menus",
      read: "/comercios/:organizationId/menu/:menuId",
      create: "/comercios/:organizationId/menus/crear",
      edit: "/comercios/:organizationId/menus/:menuId/editor",
      configuration: "/comercios/:organizationId/menus/:menuId/configuracion",
    },
    content: {
      main: "/comercios/:organizationId/contenido/:contentStatus",
      details: "/comercios/:organizationId/contenido/:contentStatus/:contentId",
    },
  },
  menu: {
    read: "/menus/:menuId",
  },
  organizations: {
    root: "/:organizationAlias",
    main: "/comercios",
    details: "/comercios/:organizationId/detalles",
    create: "/comercios/crear",
    menu: {
      main: "/:organizationAlias/menus",
      read: "/:organizationAlias/menus/:menuId",
    },
    loyaltyPublic: {
      main: "/:organizationAlias/loyalty",
    },
    order: {
      main: "/:organizationAlias/orders",
      details: "/:organizationAlias/orders/:orderId",
      status: "/:organizationAlias/orders/:orderId/status",
      link: "/:organizationAlias/orders/:orderId",
      checkout: "/:organizationAlias/orders/:orderId/checkout",
      checkoutForm: "/:organizationAlias/orders/:orderId/checkout/:formId",
    },
    reservations: {
      main: "/:organizationAlias/reservations",
      form: "/:organizationAlias/reservations/:formId",
      confirmation: "/:organizationAlias/reservations/confirmation",
    },
    branches: {
      main: "/comercios/:organizationId/sucursales",
      details: "/comercios/:organizationId/sucursales/:branchId",
      create: "/comercios/:organizationId/sucursales/crear",
    },
    pricing: {
      main: "/comercios/:organizationId/suscripcion",
    },
    // @deprecated
    menus: {
      main: "/comercios/:organizationId/menus",
      read: "/comercios/:organizationId/menu/:menuId",
      create: "/comercios/:organizationId/menus/crear",
      edit: "/comercios/:organizationId/menus/:menuId/editor",
      configuration: "/comercios/:organizationId/menus/:menuId/configuracion",
    },
    catalogo: {
      create: "/comercios/:organizationId/catalogo/crear",
      editor: "/comercios/:organizationId/catalogo/:menuId/editor",
    },
    websites: {
      main: "/comercios/:organizationId/websites",
      create: "/comercios/:organizationId/websites/crear",
      read: "/comercios/:organizationId/websites/:websiteId",
      edit: "/comercios/:organizationId/websites/:websiteId/editor",
    },
    orders: {
      main: "/comercios/:organizationId/pedidos",
      table: "/comercios/:organizationId/ordenes/:tableOwnership",
      details: "/comercios/:organizationId/pedidos/:orderId",
      print: "/comercios/:organizationId/pedidos/:orderId/print",
    },
    surveys: {
      main: "/comercios/:organizationId/surveys",
      details: "/comercios/:organizationId/surveys/:surveyId",
    },
    content: {
      main: "/comercios/:organizationId/contenido/:contentStatus",
      details: "/comercios/:organizationId/contenido/:contentStatus/:contentId",
    },
    dashboard: {
      main: "/comercios/:organizationId/dashboard/:branchId?",
    },
    loyalty: {
      main: "/comercios/:organizationId/loyalty",
    },
    customerProfile: {
      main: "/:organizationAlias/perfil",
    },
    firstSteps: {
      main: "/comercios/:organizationId/primeros-pasos",
    },
  },
};
